<template>
  <base-share-button @click="click">
    <template #icon>
      <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="25" cy="25" r="25" fill="#F8D1A4" />
        <path
          d="M24.5 29.75C25.2426 29.75 25.9851 29.51 26.6185 29.0235L36 21.8344V31.875C36 33.0482 35.0346 34 33.8438 34H15.1562C13.9654 34 13 33.0486 13 31.875V21.8344L22.3797 29.0284C23.0131 29.5109 23.7588 29.75 24.5 29.75ZM35.2682 20.5992L25.7358 27.9083C25.0085 28.4661 23.9897 28.4661 23.2624 27.9083L13.73 20.5992C13.31 20.2451 13 19.7005 13 19.125C13 17.9514 13.9658 17 15.1562 17H33.8438C35.0346 17 36 17.9514 36 19.125C36 19.7005 35.73 20.2451 35.2682 20.5992Z"
          fill="#F4FAFD"
        />
      </svg>
    </template>
    <template #title>
      {{ $t('social-share-buttons.email') }}
    </template>
  </base-share-button>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import BaseShareButton from '@vue-app/components/base/share/buttons/BaseShareButton.vue'

export default {
  name: 'EmailShareButton',
  components: { BaseShareButton },
  methods: {
    click() {
      $emit(this, 'share', 'email')
    },
  },
  emits: ['share'],
}
</script>
